import * as React from "react";
import { useContext, useMemo } from "react";
import { singleton } from "logic/singleton";
const ActionContext = singleton(
  "contexts.ActionContext",
  () => React.createContext({})
);
const AdditionalContext = {
  Provider: ({ children, value }) => {
    const contexts = useContext(ActionContext);
    const newActionContextValue = useMemo(() => ({ ...contexts, ...value }), [contexts, value]);
    return /* @__PURE__ */ React.createElement(ActionContext.Provider, { value: newActionContextValue }, children);
  },
  Consumer: ActionContext.Consumer
};
export { ActionContext, AdditionalContext };
